module.exports = __webpack_public_path__ + "1f852cd89ae26a748c285f7edffecf9f.pdf";